module.exports = __webpack_public_path__ + "img/custom-item2-2.ea0c79b.png";